import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
`;
